import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject, catchError, map, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: "root",
})
export class RegistruService {
    private token!: string;
    private httpOptions: any;

    // private registruId = new Subject<{ registruId: number }>();
    // currentRegistruId$ = this.registruId.asObservable();

    private basePath = environment.interop.basePath;
    private getRegistreDTURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.registru.listDT;

    private getRegistreListURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.registru.list;

    private getRegistreActiveListURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.registre.listActive;

    private addRegistruDocOficialURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.registru
            .storeDocumentOficial;

    private editDataRegistruURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.registru
            .modificareRegistru;

    public istoricViewURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.registru.istoric;

    private changeStatusPublicURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.registru.changePublic;

    public exportCSVRegistruURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.registru.exportCSV;

    private updateFieldURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.registru.updateField;

    constructor(private http: HttpClient) { }

    // changeRegistruId(registru_id: { registruId: number }) {
    //     this.registruId.next(registru_id);
    // }

    getRegistreDT() {
        return this.http.get(this.getRegistreDTURL, this.httpOptions);
    }

    editDataRegistru(data: any) {
        return this.http.post(this.editDataRegistruURL, data, this.httpOptions);
    }

    istoricView(id: number) {
        return this.http.get(this.istoricViewURL + id, this.httpOptions);
    }

    getRegistre() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getRegistreListURL
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                        slug: item.slug,
                    }))
                ),
                catchError((error) => {
                    console.error("Error in get registre types:", error);
                    return throwError(error);
                })
            );
    }

    getRegistreActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getRegistreActiveListURL
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                        slug: item.slug,
                    }))
                ),
                catchError((error) => {
                    console.error("Error in get registre active types:", error);
                    return throwError(error);
                })
            );
    }

    addRegistruDocOficial(data: any, id: number) {
        return this.http.post(
            this.addRegistruDocOficialURL + id,
            data,
            this.httpOptions
        );
    }

    exportRegistruCSV(data: any) {
        return this.http.post(this.exportCSVRegistruURL, data, { responseType: 'blob' as 'json' });
        // if (!isCSV) {
        //     return this.http.post(this.exportRegistruURL, data, { responseType: 'blob' as 'json' });
        // }  
        // else {
        //     return this.http.post(this.exportCSVRegistruURL, data, { responseType: 'blob' as 'json' });
        // }
    }

    updateField(id: number, data: any) {
        return this.http.post(this.updateFieldURL + id, data, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changeStatusPublicURL + id, {}, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
